import React, { useEffect, useRef, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { getPageContent } from "../../utils";
import { useAuth } from "../../hooks/useAuth";
import {
    selectDonationOrderData,
    selectDonationOrderStatus,
    selectDonationOrderError,
    initializeAsync,
} from "./donationOrderSlice";
import { Typography, Container, Paper, Box, Backdrop, CircularProgress } from "@mui/material";
import { FormWizard } from "../../components/FormWizard";
import { useParams, useNavigate } from "react-router-dom";
import { get, post } from "../../api";
import { ProjectDescription } from "../../components/FormWizard/ProjectDescription";
import { save } from "../../services/object";
// Add custom imports here

const DonationOrder = () => {
    const data = useSelector(selectDonationOrderData);
    const status = useSelector(selectDonationOrderStatus);
    const error = useSelector(selectDonationOrderError);
    const dispatch = useDispatch();
    const [activeStep, setActiveStep] = React.useState(0);
    const [formData, setFormData] = useState({});
    const [loadingOrderForm, setLoadingOrderForm] = useState(false);

    const { getUserDetailsNotAsync } = useAuth();
    const userDetails = getUserDetailsNotAsync();
    let { recordId } = useParams();
    const navigate = useNavigate();
    const [saving, setSaving] = useState(false);

    useEffect(() => {
        if (status === "idle") {
            dispatch(initializeAsync());
        }
    }, [status, dispatch]);

    useEffect(() => {
        if (recordId) {
            get("opportunity/getRecordById", {
                recordId: recordId,
            }).then(async (result) => {
                if (result.isSuccess) {
                    setFormData(result.data[0]);
                    setLoadingOrderForm(true);
                }
            });
        } else {
            setFormData({});
            setLoadingOrderForm(true);
        }
    }, []);

    const handleSubmit = (formData) => {
        let documents = [];
        if (formData.floorPlan?.length > 0) {
            documents = [...documents, ...formData.floorPlan];
        }
        if (formData.miscPlan?.length > 0) {
            documents = [...documents, ...formData.miscPlan];
        }
        setSaving(true);
        post("opportunity/createOrder", {
            id: recordId ? recordId : "",
            name: formData?.name,
            streetAddress: formData?.streetAddress,
            city: formData?.city,
            state: formData?.state,
            zipcode: formData?.zipcode,
            instructions: formData?.instructions,
            installationDate: formData?.installationDate,
            projectDescription: formData?.projectDescription,
            primaryContact: userDetails?.contact?.id,
            spaceDescription: formData?.spaceDescription,
            accountId: userDetails?.contact?.accountId,
            status: recordId && formData && formData.status ? formData.status : "In-Progress",
        }).then(async (result) => {
            if (result.isSuccess) {
                if (documents?.length > 0) {
                    let documentRecords = documents?.map((item) => {
                        if (item.parentId) {
                            return item;
                        }
                        return { ...item.file, parentId: result.data.id };
                    });

                    let documentResult = await save("document", documentRecords);
                }

                let records = result.data;
                navigate("/projectDetails/" + records.id, { replace: true });
            }
            setSaving(false);
        });
    };

    let body = (
        <Container component="main" maxWidth="sm" sx={{ mb: 4 }}>
            {loadingOrderForm && (
                <FormWizard
                    header={"Setting Up Your Donation Project"}
                    formData={formData}
                    onSubmit={handleSubmit}
                    saving={saving}
                />
            )}
        </Container>
    );

    return getPageContent(body, status, error);
};

export { DonationOrder };
